import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height", "iconWidth", "iconHeight", "color", "bgColor", "circle", "icon", "onClick", "flipH"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Image from '../Image';
import { Parent } from './style';
import { jsx as _jsx } from "react/jsx-runtime";
var Icon = function Icon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    iconWidth = _ref.iconWidth,
    iconHeight = _ref.iconHeight,
    color = _ref.color,
    bgColor = _ref.bgColor,
    circle = _ref.circle,
    icon = _ref.icon,
    onClick = _ref.onClick,
    flipH = _ref.flipH,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Parent, _objectSpread(_objectSpread({
    parentWidth: width,
    parentHeight: height,
    svgColor: color,
    bgColor: bgColor,
    circle: circle,
    onClick: onClick,
    flipH: flipH
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Image, {
      svg: true
      // eslint-disable-next-line import/no-dynamic-require
      // src={`../../../images/icons/${icon}.svg`}
      ,
      src: "/images/icons/".concat(icon, ".svg"),
      width: iconWidth || width,
      height: iconHeight || height,
      color: color
    })
  }));
};
Icon.defaultProps = {
  color: null,
  flipH: null,
  // width: '1.7142857142857142rem',
  // height: '1.7142857142857142rem',  
  width: undefined,
  height: undefined,
  iconWidth: null,
  iconHeight: null,
  bgColor: null,
  circle: false,
  onClick: null
};
export default Icon;